import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function StatsBanner() {
  const stats = [
    { value: '5000万+', label: '累计用户' },
    { value: '10万+', label: '视频总量' },
    { value: '3000万+', label: '日播放量' },
    { value: '2000+', label: '合作品牌' },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-12 bg-primary-500">
      <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6">
        {stats.map((stat, idx) => (
          <div key={idx} className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-1 whitespace-nowrap">{stat.value}</div>
            <div className="text-xs text-background-50/70 whitespace-nowrap">{stat.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}